import { MixpanelWizardStep } from 'redux/modules/mixpanel/types';
import { AspectRatioName } from 'types';
import {
  VIDEO_CLIP_DEFAULT_DURATION_SECONDS,
  VIDEO_CLIP_MAX_DURATION_SECONDS,
} from 'utils/constants';
import { secToMillis } from 'utils/time';
import { VideoFlowStep } from './types';

export const ERROR_ID = 'video-wizard-error';
export const DEFAULT_ASPECT_RATIO: AspectRatioName = 'square';
export const VIDEO_CLIP_DEFAULT_DURATION_MILLIS = secToMillis(
  VIDEO_CLIP_DEFAULT_DURATION_SECONDS,
);
export const VIDEO_CLIP_MAX_DURATION_MILLIS = secToMillis(
  VIDEO_CLIP_MAX_DURATION_SECONDS,
);

export const MIXPANEL_WIZARD_STEP_MAP: Partial<Record<
  VideoFlowStep,
  MixpanelWizardStep
>> = {
  [VideoFlowStep.OBJECTIVE]: 'objective',
  [VideoFlowStep.ASPECT_RATIO]: 'Choose Aspect Ratio',
  [VideoFlowStep.CLIP_VIDEO]: 'Clip Video',
  [VideoFlowStep.UPLOAD_VIDEO]: 'Upload Video',
};
